import { ContextCard } from '../context_card';
import { UserHeader, AnonHeader } from './user_header';
import { UserContext, AnonContext } from './user_context';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const HighlyEngaged = () => (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip id=";">Has read multiple papers, or most of one paper</Tooltip>
    }
  >
    <div className="wp-usercard-highly_engaged">
      <span>HIGHLY ENGAGED</span>
    </div>
  </OverlayTrigger>
);

/**
 *     This expects a user prop containing JSON about a user.
 *
 *     renders all relevant data about this user for a card
 */
export const UserCard = ({ user, children, anon, onProfileClick }) => {
  return (
    <ContextCard
      floatingBanner={!!user.highly_engaged && <HighlyEngaged />}
      headerContent={
        anon ? (
          <AnonHeader {...user} />
        ) : (
          <UserHeader {...user} onProfileClick={onProfileClick} />
        )
      }
      contextContent={
        anon ? <AnonContext {...user} /> : <UserContext {...user} />
      }
      contextLabel="About"
      mainLabel="Activity"
    >
      {children}
    </ContextCard>
  );
};
